import * as Yup from "yup";
export const initialValues = (data) => {
  console.log(data);
  return {
    ...data,
    ...data?.localized_data,
    google_city_id: data?.google_city?.id,
  };
};
export const structure = (options, cities, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `google_city_id`,
        kind: "select",
        type: "text",
        label: "City name*",
        width: "47%",
        placeholder: t ? t("cities.write_city_name") : "Write the city name",
        ...options?.cities
      },
      {
        name: `radius`,
        kind: "input",
        type: "number",
        label: `${t ? t("zones.radius") : "Radius"}*`,
        width: "47%",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>KM</p>,
        placeholder: t ? t("zones.radius") : "Radius",
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: "Zone name(EN)*",
        width: "47%",
        placeholder: t ? t("zones.write_zone_name") : "Write the zone name",
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: "Zone name(AR)*",
        width: "47%",
        placeholder: t ? t("zones.write_zone_name") : "Write the zone name",
      },
      {
        name: `delivery_fees`,
        kind: "input",
        type: "number",
        label: t ? t("zones.delivery_fees") : "Delivery fees",
        width: "47%",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
        placeholder: t ? t("zones.write_delivery_fees") : "Write Delivery fees",
      },
      {
        name: `is_fulfillment_center`,
        kind: "checkbox",
        type: "text",
        label: t ? t("cities.fulfillment_center") : "Fulfillment Center",
        width: "47%",
      },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    google_city_id: Yup.string().required(t ? t("vendors.error_required") : "required"),
    radius: Yup.number(t ? t("vendors.error_required") : "please enter a valid number").required(t ? t("vendors.error_required") : "required"),
    en: Yup.object().shape({
      name: Yup.string().required(t ? t("vendors.error_required") : "Required"),
    }),
    ar: Yup.object().shape({
      name: Yup.string().required(t ? t("vendors.error_required") : "Required"),
    }),
    delivery_fees: Yup.number(t ? t("vendors.error_required") : "please enter a valid number"),
    is_fulfillment_center: Yup.boolean(),
  });
